export default "__VITE_ASSET__BWvUHcKA__"